import { z } from "zod";
import { adminCountSchema, adminDaySchema, adminMicrosSchema } from "./common.js";
const featureSchema = z.enum([
    "extraction",
    "sentiment",
    "research",
    "setup",
    "categorise",
    "verdicts",
]);
export const MODEL_FEATURES = featureSchema.options;
/** What the model is asked, how often, and how often it fails. */
export const adminModelUsageSchema = z.object({
    /** The model calls go to now; null when no key is set and model features are off. */
    active: z.object({ name: z.string().min(1), model: z.string().min(1) }).nullable(),
    /** The provider's allowance, shared by every customer. */
    peak: z.object({ perMinute: adminCountSchema, limit: adminCountSchema }),
    daily: z.array(z.object({
        day: adminDaySchema,
        calls: z.record(featureSchema, adminCountSchema),
        failures: adminCountSchema,
    })),
    byFeature: z.array(z.object({
        feature: featureSchema,
        calls: adminCountSchema,
        inputTokens: adminCountSchema,
        outputTokens: adminCountSchema,
        /** What these calls cost, priced when each was made (`model_calls.cost_usd_micros`). */
        costUsdMicros: adminMicrosSchema,
        failures: adminCountSchema,
        p50Ms: adminCountSchema,
        p95Ms: adminCountSchema,
    })),
    /** One row per model the ledger recorded in the range, busiest first. */
    byModel: z.array(z.object({
        model: z.string().min(1),
        calls: adminCountSchema,
        failures: adminCountSchema,
        costUsdMicros: adminMicrosSchema,
        p50Ms: adminCountSchema,
    })),
});
//# sourceMappingURL=model-usage.js.map